const TipoInternacaoOptions = [
  { id: 1, text: "Clínica", value:"Clinica" },
  { id: 2, text: "Cirúrgico", value:"Cirurgico" },
];

export { TipoInternacaoOptions};
